import {h, Component, Fragment} from 'preact';
import {useLayoutEffect, useRef} from 'preact/hooks';
import {
	sendRequest,
	calcCommisionBySppsService,
	formatPrice,
	useRunAfterUpdate,
	stickyPayBlock,
	getErrorRequestMessage
} from "../../tools";
import Pay from "./Pay";
import SppsServiceRow from "./SppsServiceRow";
import SirenaContractRow from "./SirenaContractRow";
import AmountBlock from "./AmountBlock";
import ServiceRow from "./ServiceRow";
import ModalDialog from "./ModalDialog";
import GroupModalDialog from "./GroupModalDialog";
import ContractPayConfirmModal from "./ContractPayConfirmModal";

class Form extends Component {
    /**
     * @param {{getAccountsUrl: string, getSppsDebtsUrl: string, payRulesUrl: string, createOrderUrl: string, bankCards: {id: number, pan: string, paymentSystem: string, icon: string}[], texts: {}, allowedPayment: boolean, paymentUrl: string}} props
     */
    constructor(props){
        super(props);

        this.state = {
            accounts: [],
            maximumAccountsCount: 0,
            selectedContractdIds: [], // Массив отмеченных к оплате составных id шников договоров сирены. Формат ID: accountId#contractId
            contractdIds: [], // Массив составных id шников договоров сирены. Формат ID: accountId#contractId
            selectedSppsDebt: [], // Массив отмеченных к оплате составных id шников услуг сппс. Формат ID: accountId#serviceId, где serviceId - ID услуги в СППС
            customAmounts: {}, // Объект произвольных сумм по услугам, введённых пользователем. Формат ключа accountId_serviceId, где serviceId - ID услуги в СППС
            bankCardId: props.bankCards.length ? props.bankCards[0].id:null,
			saveBankCard: false,
            selectedFineForContractsIds: [],
            productParams: props.productParams,
            serviceFormParams: props.serviceFormParams,
            isModalDialogActive: false,
            modalDialogParams: {
                accountId: null,
                contractId: null,
                address: null,
                enterUrl: ''
            },
            isGroupModalDialogActive: false,
            groupModalDialogParams: {},
            isModalContractPayConfirmActive: false,
            messages: [],
            layoutEffect: false,
            afterOpenGoPay: props.afterOpenGoPay
        }

        // В стейте еще предполагаются данные с динамическими ключами
        // Form.getKeySppsDebtsState(accountId)
        // Form.getKeySppsDebtsIsOpenState(accountId)
        // Form.getKeySppsDebtsIsLoadedState(accountId)

        this.inititalLoaded = false;

        window.debtsFormRefresh = () => this.refresh();
    }


    componentDidUpdate() {
        if (this.state.afterOpenGoPay && !this.state.layoutEffect) {
            this.setState({ layoutEffect: true });
            this.handlerOnClickCreateOrder();
        }
    }

    /* ModalDialogs */
    openModalDialog(isOpen, address, accountId, contractId, enterUrl){
        this.setState({
            isModalDialogActive: isOpen,
            modalDialogParams: {
                accountId: accountId,
                contractId: contractId,
                address: address,
                enterUrl: enterUrl
            }
        });
    }

	openModalContractPayConfirm(isOpen, address, accountId, contractId){
        this.setState({
			isModalContractPayConfirmActive: isOpen,
			modalDialogParams: {
                accountId: accountId,
                contractId: contractId,
                address: address
            }
        });
    }

    handlerCreateOrderForContract(account, contract, canEnterMeterReadings, enterUrl){
        //Логика открытия модалки
        let accountId = account.id;
        let contractId = contract.id;
		const isTerminal = this.props.isTerminal;

        var currentPreiod = 0;
		if (contract['meterDevices'].length>0) {
            contract['meterDevices'].forEach(function(e){
                currentPreiod += e.currentPreiod;
            });
        }
        //Если открывать не надо переходим к вызову по кнопке "Оплатить"
		if (!canEnterMeterReadings || currentPreiod>0) {
			if(!isTerminal)
			{
				//Если не терминал, то открываем модалку, в которой выбирается действующая карта или новая карта с переходом на оплату
				this.openModalContractPayConfirm(true, account.address, accountId, contractId);
			}
			else
			{
				// Если терминал, переходим сразу на оплату
				this.createOrderForContract(accountId, contractId);
			}
            return;
        }

        this.openModalDialog(true, account.address, accountId, contractId, enterUrl);
    }

    handlerContractPay(){
        this.setState({isModalDialogActive: false});

        let accountId = this.state.modalDialogParams.accountId;
        let contractId = this.state.modalDialogParams.contractId;
        this.createOrderForContract(accountId, contractId);
    }

    openGroupDialog(isOpen, data){
        this.setState({isGroupModalDialogActive: isOpen, groupModalDialogParams: data});
    }

    getAllAddressesForAttention(){
        const {selectedContractdIds, accounts} = this.state;

        const data = {
            items: [],
        };

        if(selectedContractdIds.length > 0)
        {
            selectedContractdIds.forEach(compositeId => {
                const [accountId, contractId] = compositeId.split('#').map(id => id);
                const account = accounts.find(item => item.id === accountId);
                if(account)
                {
                    const {contracts} = account;
                    const contract = !!contracts && contracts.find(item => item.id === contractId);
                    if(contract)
                    {
                        contract.meterDevices.forEach(meterDevice => {
                            let currentPreiod = meterDevice.currentPreiod;
							if (meterDevice.canEnterMeterReadings && currentPreiod==0) {
                                data.items.push({
                                    address: account.address,
                                    serialNumber: meterDevice.serialNumber,
                                });
                            }
                        });
                    }
                }
            });
        }
        return data;
    }

    handlerOnClickCreateOrder(){
        //Логика открытия модалки
        var data = this.getAllAddressesForAttention();
		if (data.items.length == 0) {
            this.onClickCreateOrder();
            return;
        }
        this.openGroupDialog(true, data);
    }

    handlerGroupContractPay(){
        this.setState({isGroupModalDialogActive: false});
        this.onClickCreateOrder();
    }
    /** end Modal dialogs */

    componentDidMount(){

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const accountId = urlParams.get('payDisableDebtsForAccount');

        if(accountId && accountId !=='')
        {
            this.fetchSingleAccount(accountId);

        } else
        {
            this.fetchAccounts();
        }

        stickyPayBlock();
    }

    checkFineForContract = (contractId, accountId) => (e) => {
        e.preventDefault();
        let selectedFineForContractsIds = this.state.selectedFineForContractsIds.slice();
        const compositeId = this.getKeyAmountInput(accountId, contractId);
        let index = selectedFineForContractsIds.indexOf(compositeId);
		if(index !== -1) {
            selectedFineForContractsIds.splice(index, 1);
		} else {
            selectedFineForContractsIds.push(compositeId);
        }
        this.setState({selectedFineForContractsIds});
    }

    getDeleteUrl = (url) => {
        return (this.state.accounts.length == 1) ? url+'&last=1' : url;
    }

    render(props, state, context){
        const {accounts, maximumAccountsCount, messages} = state;
        const {isTerminal} = props;
        const maximumAccountsAdded = accounts.length >= maximumAccountsCount;
		if(accounts.length <= 0) {
            return (
                <div className="row">
                    <div className="col col-12 col-lg-8">
                        <button href="#" data-modal-url="/account/add/" data-reach-goal="adress_add" className="button-primary">+ Добавить адрес</button>
                    </div>
                </div>
            )
        }

        return (
            <div className="row">
				{this.state.isModalContractPayConfirmActive &&
					<ContractPayConfirmModal
						setIsOpen={this.openModalContractPayConfirm.bind(this)}
						handlerPay={this.handlerContractPay.bind(this)}
						modalDialogParams={this.state.modalDialogParams}
						bankCardId={this.state.bankCardId}
						bankCards={props.bankCards}
						onChangeBankCard={this.onChangeBankCard}
						saveBankCard={this.state.saveBankCard}
						changeSaveBankCard={this.changeSaveBankCard.bind(this)}
					/>
				}
                {this.state.isModalDialogActive &&
                    <ModalDialog
                        setIsOpen={this.openModalDialog.bind(this)}
                        handlerPay={this.handlerContractPay.bind(this)}
                        modalDialogParams={this.state.modalDialogParams}
						bankCardId={this.state.bankCardId}
						bankCards={props.bankCards}
						onChangeBankCard={this.onChangeBankCard}
						saveBankCard={this.state.saveBankCard}
						changeSaveBankCard={this.changeSaveBankCard.bind(this)}
						isTerminal={isTerminal}
                    />
                }
                {this.state.isGroupModalDialogActive &&
                    <GroupModalDialog
                        setIsOpen={this.openGroupDialog.bind(this)}
                        handlerPay={this.handlerGroupContractPay.bind(this)}
                        modalDialogParams={this.state.groupModalDialogParams}
						bankCardId={this.state.bankCardId}
						bankCards={props.bankCards}
						onChangeBankCard={this.onChangeBankCard}
						saveBankCard={this.state.saveBankCard}
						changeSaveBankCard={this.changeSaveBankCard.bind(this)}
						isTerminal={isTerminal}
                    />
                }

                <div className="col col-12 col-lg-8">
                    <div className="buttons-row">
                        <div className="col-lg-6 buttons-row__checkbox">
                            <label className="checkbox debt-table-item__checkbox">
                                <input className="checkbox__input" type="checkbox" onChange={this.onChangeSelectAllCheckbox()} checked={this.ifAllChecked()}/><span className="checkbox__label debts-item-checkbox"/>
                                Выбрать все
                            </label>
                        </div>
                        <div className="col-lg-6 buttons-row__buttons">
                            <a href="/accounts-details/" className="button-secondary buttons-row__button">Детализация счёта</a>
                            <button href="#" data-modal-url="/account/add/" data-reach-goal="adress_add" disabled={maximumAccountsAdded} className="button-secondary buttons-row__button">{maximumAccountsAdded ? "Добавлено максимальное количество адресов":"+ Добавить адрес"}</button>
                        </div>
                    </div>
                    {accounts.map((account) => {
                        const {contracts} = account;

                        const sppsDebtsIsOpen = !!state[Form.getKeySppsDebtsIsOpenState(account.id)];
                        const sppsDebtsIsLoaded = !!state[Form.getKeySppsDebtsIsLoadedState(account.id)];
                        const sppsDebts = state[Form.getKeySppsDebtsState(account.id)];
                        return (
                            <Fragment>
                                {!!contracts && contracts.length > 0 && (
                                    contracts.map(contract => {
                                            const prodType = this.getProdType(contract.prodType);
                                            const compositeId = this.getKeyAmountInput(account.id, contract.id);
                                            return (
                                                <section className="debt-table main__section js__toggle-block contract">
                                                    <div className="debt-table__header">
                                                        <div className="debt-table__header-contract">
                                                            {
                                                                !!props.allowedPayment && <Fragment>
                                                                    <div className="debt-table-item__col">
                                                                        <label className={this.getSirenaContractAmounts(contract).total > 0 ? "checkbox debt-table-item__checkbox":"checkbox debt-table-item__checkbox disabled"}>
                                                                            <input className="checkbox__input" type="checkbox" onChange={this.onChangeSirenaContractCheckbox(account.id, contract.id)} checked={this.isSelectedSirenaContract(account.id, contract.id)}/><span className="checkbox__label debts-item-checkbox"/>
                                                                        </label>
                                                                    </div>
                                                                </Fragment>
                                                            }
                                                            <div className="debt-table__titles">
                                                                <div className="debt-table__title-1">{account.address}</div>
                                                                <div className="debt-table__title-2">ЛС {account.id}
                                                                    {
                                                                        (prodType && prodType == 'service')
																		&& <span className="debt-table__title-additional">{contract.prodName}</span>
                                                                    }
                                                                    {
                                                                        (prodType && prodType == 'contract') && !props.allowedPayment && (
                                                                            <div className="debt-table__title-additional">{contract.prodName}</div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button className="debt-table__delete-btn" data-modal-url={this.getDeleteUrl(account.deleteUrl)}>Удалить</button>
                                                    </div>
                                                    {contract.promisedPaymentActivated && <div class="trust-payment-info">
                                                        <div class="trust-payment-info__body">
                                                            <svg class="trust-payment-info__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 5C9 5.55228 8.55229 6 8 6C7.44772 6 7 5.55228 7 5C7 4.44772 7.44772 4 8 4C8.55229 4 9 4.44772 9 5Z" fill="#D1D1D2"/>
                                                                <path d="M7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11V8Z" fill="#D1D1D2"/>
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="#D1D1D2"/>
                                                            </svg>
                                                            <div class="trust-payment-info__text">
                                                                Подключена услуга <span>«Обещанный платеж»</span>
                                                            </div>
                                                            <div class="trust-payment-info__link">
                                                                <a href="/service/view/?id=87de25b0-bfa5-4a88-b459-9286740104af">Подробнее в разделе «Услуги/Обещанный платеж»</a>
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    {
                                                        (prodType && prodType == 'contract')
                                                        && <div className="debt-table__body sirena-contract">
                                                            <SirenaContractRow
                                                                contract={contract}
                                                                account={account}
                                                                isChecked={props.allowedPayment && this.isSelectedSirenaContract(account.id, contract.id)}
                                                                onChangeCheckbox={this.onChangeSirenaContractCheckbox}
                                                                formParams={props}
                                                                amounts={this.getSirenaContractAmounts(contract)}
                                                                onChangeAmountInput={this.onChangeAmountInput.bind(this)}
                                                                createOrderForContract={this.handlerCreateOrderForContract.bind(this)}
                                                                checkFineForContract={this.checkFineForContract.bind(this)}
                                                                isFineChecked={this.isFineChecked(compositeId)}
                                                                messages={messages}
                                                            />
                                                        </div>
                                                    }
                                                    {
                                                        (prodType && prodType == 'service')
                                                        && <ServiceRow
                                                            contract={contract}
                                                            account={account}
                                                            isChecked={props.allowedPayment && this.isSelectedSirenaContract(account.id, contract.id)}
                                                            onChangeCheckbox={this.onChangeSirenaContractCheckbox}
                                                            formParams={props}
                                                            amounts={this.getSirenaContractAmounts(contract)}
                                                            onChangeAmountInput={this.onChangeAmountInput.bind(this)}
                                                            createOrderForContract={this.createOrderForContract.bind(this)}
                                                            checkFineForContract={this.checkFineForContract.bind(this)}
                                                            isFineChecked={this.isFineChecked(compositeId)}
                                                        />
                                                    }
                                                    {
                                                        !!props.allowedPayment
                                                        && <Fragment>
                                                            {
                                                                (prodType && prodType != 'service')
                                                                && <div className="debt-table__toggle-btn-section">
                                                                    <button className="debt-table__toggle-btn" onClick={this.onClickShowSppsDebts(account.id)}>{!sppsDebtsIsLoaded ? 'Проверить':(sppsDebtsIsOpen ? 'Скрыть':'Показать')} услуги других поставщиков (вода, тепло, кап. ремонт...)</button>
                                                                </div>
                                                            }
                                                            {sppsDebtsIsOpen && (prodType && prodType != 'service') && (
                                                                <div className="debt-table__body has-scrollbar">
                                                                    {sppsDebts && sppsDebts.length ? sppsDebts.map((debt => (
                                                                        <SppsServiceRow
                                                                            debt={debt}
                                                                            account={account}
                                                                            isChecked={this.isSelectedSppsService(account.id, debt.serviceId, debt.accountId)}
                                                                            onChangeCheckbox={this.onChangeSppsServiceCheckbox}
                                                                            isCheckedPlanAccruals={this.isSelectedSppsService(account.id, debt.serviceId, debt.accountId, 1)}
                                                                            formParams={props}
                                                                            amounts={this.getSppsServiceAmounts(debt)}
                                                                            onChangeAmountInput={this.onChangeAmountInput.bind(this)}
                                                                        />
                                                                    ))):(
                                                                        <div className="debt-table-item-2 debt-table__item">
                                                                            <div className="debt-table-item__row">
                                                                                <div className="debt-table-item-2__col">
                                                                                </div>
                                                                                <div className="debt-table-item-2__col debt-table-item-2__col_fg_1">
                                                                                    <div className="debt-table-item-2__text">
                                                                                        Задолженность по другим поставщикам не найдена
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </Fragment>
                                                    }
                                                </section>
											)}
                                    )
                                )}
                            </Fragment>

                        )
                    })}
                </div>
                <div className="col col-12 col-lg-4">
                    {
                        props.allowedPayment
                            ? <Pay
                                amount={this.calcAmount()}
                                bankCardId={this.state.bankCardId}
                                formParams={props}
                                onClickPay={this.handlerOnClickCreateOrder.bind(this)} /*onClickCreateOrder*/
                                onChangeBankCard={this.onChangeBankCard}
								saveBankCard={this.state.saveBankCard}
								changeSaveBankCard={this.changeSaveBankCard.bind(this)}
                            />
                            :<AmountBlock
                                amount={this.calcAmount()}
                                paymentUrl={props.paymentUrl}
                            />
                    }
                </div>
            </div>

        )
    }

    getProdType(prodType){
		for(let product of this.state.productParams.types) {
			if(parseInt(product.id) == parseInt(prodType)) {
                return product.prodType;
            }
        }
        return false;
    }

    fetchOrders(contractIds){
        sendRequest(this.props.getAllOrdersUrl, {
            body: {contractIds: contractIds},
            type: 'POST',
            showLoader: !this.inititalLoaded
        }).then(response => {
            switch(response.status)
            {
                case 200:
                    const orders = response.data;
                    let accounts = this.state.accounts;
                    let unselectedContractdIds = [];
					for (let account of accounts) {
						for (let contract of account.contracts) {
							if(orders[contract.contractGlobalId]) {
								for(let order of orders[contract.contractGlobalId]) { // среди ордеров
									if(!!order.smrOrderType && order.smrOrderType.indexOf('Обещанный платеж') !== -1) {
                                        contract.promisedPayment = order;
                                        unselectedContractdIds.push(this.getKeyAmountInput(account.id, contract.id));
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    this.unselectContracts(unselectedContractdIds);
                    this.forceUpdate();
                    this.inititalLoaded = true;
                    break;

                default:
                    throw new Error(`Fetching orders error. Status ${response.status}. Status text: ${response.statusText}`);
            }
        }).catch(error => Form.showRequestError(error));
    }

    unselectContracts(unselectContracts = []){
        let selectedContractdIds = this.state.selectedContractdIds;
        const newSelectedContractdIds = selectedContractdIds.filter(contractId => {
				if(unselectContracts.indexOf(contractId) == -1) {
                    return true;
                }
                return false;
            }
        );
        this.setState({selectedContractdIds: newSelectedContractdIds});
    }

    /**
     * Получаем только один аккаунт
     * @param accountId
     */
    fetchSingleAccount(accountId){

        console.log('Fetching single account');

        sendRequest(this.props.getAccountsUrl, {
            showLoader: !this.inititalLoaded
        }).then(response => {
            switch(response.status)
            {
                case 200:

                    const accounts = response.data.items.filter((item) => item.id === accountId)

                    this.setState({
                        accounts: accounts,
                        maximumAccountsCount: accounts.length,
                        messages: response.data.messages
                    });

                    if(this.inititalLoaded === false)
                    {
                        const selectedContractdIds = [];
                        const contractdIds = [];
                        const selectedFineForContractsIds = [];
                        let globalIds = [];
                        response.data.items.forEach(account => {
                            const {contracts} = account;
                            if(contracts && contracts.length > 0)
                            {
                                contracts.forEach(contract => {
                                    if(contract.totalAmount > 0)
                                    {
                                        contractdIds.push({accountId: account.id, contractId: contract.id});
                                        selectedFineForContractsIds.push(this.getKeyAmountInput(account.id, contract.id));
                                    }
                                    if(contract.contractGlobalId)
                                    {
                                        globalIds.push(contract.contractGlobalId);
                                    }
                                    selectedContractdIds.push(this.getKeyAmountInput(account.id, contract.id));
                                })
                            }
                        });

                        if(globalIds.length)
                        {
                            this.fetchOrders(globalIds);
                        }

                        this.setState({
                            selectedContractdIds,
                            contractdIds,
                            selectedFineForContractsIds
                        });
                    }

                    this.inititalLoaded = true;

                    // И сразу получаем все долги по другим сервисам
                    this.fetchSppsDebts(accountId);

                    break;

                default:
                    throw new Error(`Fetching single account error. Status ${response.status}. Status text: ${response.statusText}`);
            }
        }).catch(error => Form.showRequestError(error));
    }


    fetchAccounts(){

        console.log('Fetching all accounts');

        sendRequest(this.props.getAccountsUrl, {
            showLoader: !this.inititalLoaded
        }).then(response => {
            switch(response.status)
            {
                case 200:
                    this.setState({
                        accounts: response.data.items,
                        maximumAccountsCount: response.data.maximumAccountsCount,
                        messages: response.data.messages
                    });

                    if(this.inititalLoaded === false)
                    {
                        const selectedContractdIds = [];
                        const contractdIds = [];
                        const selectedFineForContractsIds = [];
                        let globalIds = [];
                        response.data.items.forEach(account => {
                            const {contracts} = account;
                            if(contracts && contracts.length > 0)
                            {
                                contracts.forEach(contract => {
                                    if(contract.totalAmount > 0)
                                    {
                                        contractdIds.push({accountId: account.id, contractId: contract.id});
                                        selectedFineForContractsIds.push(this.getKeyAmountInput(account.id, contract.id));
                                    }
                                    if(contract.contractGlobalId)
                                    {
                                        globalIds.push(contract.contractGlobalId);
                                    }
                                    if(!contract.promisedPayment)
                                    {
                                        selectedContractdIds.push(this.getKeyAmountInput(account.id, contract.id));
                                    }
                                })
                            }
                        });
						if(globalIds.length) {
                            this.fetchOrders(globalIds);
                        }
						this.setState({selectedContractdIds, contractdIds, selectedFineForContractsIds});
                    }

                    this.inititalLoaded = true;

                    break;

                default:
                    throw new Error(`Fetching all accounts error. Status ${response.status}. Status text: ${response.statusText}`);
            }
        }).catch(error => Form.showRequestError(error));
    }

    fetchSppsDebts(accountId){
        sendRequest(this.props.getSppsDebtsUrl, {
            body: {accountId: accountId},
            showLoader: true
        }).then(response => {
            switch(response.status)
            {
                case 200:

                    const sppsServices = response.data.items ? response.data.items:[]

                    const newState = {};

                    newState[Form.getKeySppsDebtsState(accountId)] = sppsServices;
                    newState[Form.getKeySppsDebtsIsOpenState(accountId)] = true;
                    newState[Form.getKeySppsDebtsIsLoadedState(accountId)] = true;

                    sppsServices.forEach(sppsService => {
                        // Подкл. потребит., откл. за неоплату
                        if(sppsService.serviceId === 43739)
                        {
                            newState.selectedSppsDebt = [...this.state.selectedSppsDebt, {
                                accountId,
                                serviceId: sppsService.serviceId,
                                debtAccountId: accountId,
                                isPlan: sppsService.planAccruals
                            }]
                        }
                    })

                    this.setState(newState);

                    break;

                default:
                    throw new Error(`Fetching SPPS debts error. Status ${response.status}. Status text: ${response.statusText}`);
            }
        }).catch(error => Form.showRequestError(error));
    }

    refresh(){
        this.fetchAccounts();
    }

    createOrder(){
        const self = this;
        const {selectedContractdIds, selectedSppsServicesIds, accounts, selectedSppsDebt,} = this.state;
        const props = this.props;

        const data = {
            items: [],
            bankCardId: this.state.bankCardId,
            saveBankCard: this.state.saveBankCard ? 1:0,
        };

        if(selectedContractdIds.length > 0)
        {
            window.reachGoal('oplata');
            selectedContractdIds.forEach(compositeId => {
                const [accountId, contractId] = compositeId.split('#').map(id => id);
                const account = accounts.find(item => item.id === accountId);
                if(account)
                {
                    const {contracts} = account;
                    const contract = !!contracts && contracts.find(item => item.id === contractId);
                    const isFineChecked = this.isFineChecked(compositeId);
                    if(contract)
                    {
                        const contractAmounts = this.getSirenaContractAmounts(contract);
                        if(contractAmounts.debt > 0 || contractAmounts.fine > 0)
                        {
                            data.items.push({
                                accountId,
                                contractId,
                                type: 'sirena_contract',
                                amount: contractAmounts.debt,
                                fineAmount: isFineChecked ? contractAmounts.fine:0,
                            });
                        }
                    }
                }
            });
        }

        if(selectedSppsDebt.length > 0)
        {
            const addDataItem = function(accountId, sppsServiceId, amount, debtAccountId){
                data.items.push({accountId, sppsServiceId, type: 'spps_service', amount, debtAccountId});
            };

            selectedSppsDebt.forEach(sppsService => {
                const {accountId, serviceId, debtAccountId, isPlan} = sppsService;
                const debts = this.state[Form.getKeySppsDebtsState(accountId)];
                const debt = !!debts && debts.find(item => item.accountId === debtAccountId && item.serviceId === +serviceId);

                if(debt)
                {
                    const debtAmounts = self.getSppsServiceAmounts(debt);

                    if(debtAmounts.debt > 0 || debtAmounts.plan)
                    {
                        let amount = 0;

                        if(isPlan === 0)
                        {
                            amount += Math.max(0, parseFloat(debtAmounts.debt) || 0);

                            if(this.isSelectedSppsService(accountId, serviceId, debtAccountId, 1))
                            {
                                amount += Math.max(0, parseFloat(debtAmounts.plan) || 0);
                            }
						}
						else if(!this.isSelectedSppsService(accountId, serviceId, debtAccountId))
                        {
                            amount += Math.max(0, parseFloat(debtAmounts.plan) || 0);
                        }

                        if(amount > 0)
                        {
                            addDataItem(accountId, debt.serviceId, amount, debtAccountId);
                        }
                    }


                    if(debt.fineServiceId && debtAmounts.fine > 0)
                    {
                        addDataItem(accountId, debt.fineServiceId, debtAmounts.fine, debtAccountId);
                    }
                }
            });
        }

        if(!data.items.length)
        {
            $.disMsg('Выберите услуги для оплаты', {type: 'false'});
            return false;
        }

        sendRequest(this.props.createOrderUrl, {
            body: data,
            type: 'POST',
            showLoader: true
        }).then(response => {
            switch(response.status)
            {
                case 200:
                    const order = response.data;
                    if(order.id)
                    {
                        if(window.ajaxIndicatior) window.ajaxIndicatior.show();
                        window.location = order.paymentUrl;
					}
					else throw new Error(`Status 200. Status text: Ошибка создания заказа`);
                    break;

                default:
                    throw new Error(`Create order error. Status ${response.status}. Status text: ${response.statusText}`);
            }
        }).catch(error => Form.showRequestError(error));
    }

    createOrderForContract(accountId, contractId){
        const self = this;
        const {selectedContractdIds, selectedSppsServicesIds, accounts, selectedSppsDebt} = this.state;
        const props = this.props;

        const data = {
            items: [],
            bankCardId: this.state.bankCardId,
            saveBankCard: this.state.saveBankCard ? 1:0,
        };

        const account = accounts.find(item => item.id === accountId);
        if(account)
        {
            const {contracts} = account;
            const contract = !!contracts && contracts.find(item => item.id === contractId);
            if(contract)
            {
                const contractAmounts = this.getSirenaContractAmounts(contract);
                const compositeId = this.getKeyAmountInput(accountId, contractId);
                const isFineChecked = this.isFineChecked(compositeId);
                if(contractAmounts.debt > 0 || contractAmounts.fine > 0)
                {
                    data.items.push({
                        accountId,
                        contractId,
                        type: 'sirena_contract',
                        amount: parseFloat(contractAmounts.debt),
                        fineAmount: isFineChecked ? contractAmounts.fine:0,
                    });
                }
            }
        }

        /*
        if(selectedSppsDebt.length > 0)
        {
            const addDataItem = function(accountId, sppsServiceId, amount, debtAccountId) {
                data.items.push({accountId, sppsServiceId, type: 'spps_service', amount, debtAccountId});
            };

            selectedSppsDebt.forEach(sppsService => {
                const {accountId, serviceId, debtAccountId, isPlan} = sppsService;
                const debts = this.state[Form.getKeySppsDebtsState(accountId)];
                const debt = !!debts && debts.find(item => item.accountId === debtAccountId && item.serviceId === + serviceId);

                if(debt)
                {
                    const debtAmounts = self.getSppsServiceAmounts(debt);

                    if(debtAmounts.debt > 0 || debtAmounts.plan)
                    {
                        let amount = 0;

                        if(isPlan === 0)
                        {
                            amount += Math.max(0, parseFloat(debtAmounts.debt) || 0);

                            if(this.isSelectedSppsService(accountId, serviceId, debtAccountId, 1))
                            {
                                amount += Math.max(0, parseFloat(debtAmounts.plan) || 0);
                            }
                        }
                        else if(!this.isSelectedSppsService(accountId, serviceId, debtAccountId))
                        {
                            amount += Math.max(0, parseFloat(debtAmounts.plan) || 0);
                        }

                        if(amount > 0)
                        {
                            addDataItem(accountId, debt.serviceId, amount, debtAccountId);
                        }
                    }


                    if(debt.fineServiceId && debtAmounts.fine > 0)
                    {
                        addDataItem(accountId, debt.fineServiceId, debtAmounts.fine, debtAccountId);
                    }
                }
            });
        }
        */
        if(!data.items.length)
        {
            $.disMsg('Выберите услуги для оплаты', {type: 'false'});
            return false;
        }

        sendRequest(this.props.createOrderUrl, {
            body: data,
            type: 'POST',
            showLoader: true
        }).then(response => {
            switch(response.status)
            {
                case 200:
                    const order = response.data;
                    if(order.id)
                    {
                        if(window.ajaxIndicatior) window.ajaxIndicatior.show();
                        window.location = order.paymentUrl;
					}
					else throw new Error(`Status 200. Status text: Ошибка создания заказа`);
                    break;

                default:
                    throw new Error(`Create order for contract error. Status ${response.status}. Status text: ${response.statusText}`);
            }
        }).catch(error => Form.showRequestError(error));
    }

    isSelectedSirenaContract = (accountId, contractId) => {
        let p = this.state.selectedContractdIds.indexOf(this.getKeyAmountInput(accountId, contractId));
        return this.state.selectedContractdIds.indexOf(this.getKeyAmountInput(accountId, contractId)) !== -1;
    };

    isSelectedSirenaContractMultiple = (accountId, contracts) => {
        contracts.map(contract => {
			if(this.state.selectedContractdIds.indexOf(this.getKeyAmountInput(accountId, contract.id)) == -1) {
                return false;
            }
        });
        return true;
    };

    onChangeAccountCheckbox = (accountId, contracts) => (e) => {
        e.preventDefault();
        let selectedContractdIds = this.state.selectedContractdIds.slice();
        contracts.map(contract => {
            let compositeId = this.getKeyAmountInput(accountId, contract.id);
            let index = selectedContractdIds.indexOf(compositeId);
			if(index !== -1) {
                selectedContractdIds.splice(index, 1);
			} else {
                selectedContractdIds.push(compositeId);
            }
        });
        this.setState({selectedContractdIds});
    };

    onChangeSelectAllCheckbox = () => e => {
        e.preventDefault();
        let selectedContractdIds = [];
		if(e.target.checked) {
            selectedContractdIds = this.state.selectedContractdIds.slice();
            this.state.contractdIds.map(item => {
                const compositeId = this.getKeyAmountInput(item.accountId, item.contractId);
                const index = selectedContractdIds.indexOf(compositeId);
				if(index == -1) {
                    selectedContractdIds.push(compositeId);
                }
            });
        }
        this.setState({selectedContractdIds: selectedContractdIds});
    }

    ifAllChecked = () => {
        let selectedContractdIds = this.state.selectedContractdIds.slice();
        let result = true;
        this.state.contractdIds.map(item => {
            const compositeId = this.getKeyAmountInput(item.accountId, item.contractId);
            const index = selectedContractdIds.indexOf(compositeId);
			if(index == -1) {
                result = false;
            }
        });
        return result;
    }

    onChangeSirenaContractCheckbox = (accountId, contractId) => (e) => {
        e.preventDefault();
        let selectedContractdIds = this.state.selectedContractdIds.slice();
        const compositeId = this.getKeyAmountInput(accountId, contractId);
        const index = selectedContractdIds.indexOf(compositeId);

        if(index !== -1) selectedContractdIds.splice(index, 1);
        else selectedContractdIds.push(compositeId);
        this.setState({selectedContractdIds});
    };

    isSelectedSppsService = (accountId, serviceId, debtAccountId, isPlan = 0) => {
        return this.state.selectedSppsDebt.findIndex((debt) => debt.serviceId === serviceId && debt.debtAccountId === debtAccountId && debt.accountId === accountId && debt.isPlan === isPlan) !== -1;
    };

    onChangeSppsServiceCheckbox = (accountId, serviceId, debtAccountId, isPlan = 0) => (e) => {
        e.preventDefault();
        const selectedSppsDebtKey = this.state.selectedSppsDebt.findIndex((debt) => debt.serviceId === serviceId && debt.debtAccountId === debtAccountId && debt.accountId === accountId && debt.isPlan === isPlan);

        this.setState({
            selectedSppsDebt: selectedSppsDebtKey !== -1
                ? this.state.selectedSppsDebt.filter((debt) => !(debt.serviceId === serviceId && debt.debtAccountId === debtAccountId && debt.accountId === accountId && debt.isPlan === isPlan))
                :[...this.state.selectedSppsDebt, {accountId, serviceId, debtAccountId, isPlan}]

        });
    };

    getSirenaContractAmounts(contract){
        const {customAmounts} = this.state;

        const amounts = {
            debt: contract.debtAmount,
            fine: contract.fineAmount,
            comission: 0,
            total: 0,
        };

        if(this.isSelectedSirenaContract(contract.accountId, contract.id))
        {
            if(contract.sppsServiceDebtInfo)
            {
                const customDebtAmount = customAmounts[this.getKeyAmountInput(contract.accountId, contract.sppsServiceDebtInfo.id)];
                if(customDebtAmount !== undefined)
                {
                    amounts.debt = customDebtAmount;
				}
				else amounts.debt = Math.max(0, amounts.debt);
            }

            if(contract.sppsServiceFineInfo)
            {
                const customFineAmount = customAmounts[this.getKeyAmountInput(contract.accountId, contract.sppsServiceFineInfo.id)];
                if(customFineAmount !== undefined)
                {
                    amounts.fine = customFineAmount;
				}
				else amounts.fine = Math.max(0, amounts.fine);
            }
        }

        if(contract.sppsServiceDebtInfo)
        {
            amounts.comission += calcCommisionBySppsService(parseFloat(amounts.debt) || 0, contract.sppsServiceDebtInfo);
        }

        if(contract.sppsServiceFineInfo)
        {
            amounts.comission += calcCommisionBySppsService(parseFloat(amounts.fine) || 0, contract.sppsServiceFineInfo);
        }

        amounts.total = Math.max(0, parseFloat(amounts.debt) || 0) + Math.max(0, parseFloat(amounts.fine) || 0) + amounts.comission;

        return amounts;
    }

    getSppsServiceAmounts(debt){
        const {customAmounts} = this.state;

        const amounts = {
            debt: debt.debtAmount,
            fine: debt.fineAmount,
            plan: debt.planAccruals || 0,
            planComission: 0,
            comission: 0,
            total: 0,
        };


        const isSelectedSppsService = this.isSelectedSppsService(debt.sirenaAccountId, debt.serviceId, debt.accountId);
        const isSelectedSppsPlanAccrualsService = this.isSelectedSppsService(debt.sirenaAccountId, debt.serviceId, debt.accountId, 1);

        if(isSelectedSppsService)
        {
            if(debt.debtServiceInfo)
            {
                const customDebtAmount = customAmounts[this.getKeyAmountInput(debt.sirenaAccountId, debt.serviceId, debt.accountId)];
                if(customDebtAmount !== undefined)
                {
                    amounts.debt = customDebtAmount;
				}
				else amounts.debt = Math.max(0, amounts.debt);
            }

            if(debt.fineServiceId && debt.fineServiceInfo)
            {
                const customFineAmount = customAmounts[this.getKeyAmountInput(debt.sirenaAccountId, debt.fineServiceId + '_' + debt.serviceId, debt.accountId)];
                if(customFineAmount !== undefined)
                {
                    amounts.fine = customFineAmount;
				}
				else amounts.fine = Math.max(0, amounts.fine);
            }
        }
        if(isSelectedSppsPlanAccrualsService)
        {
            if(debt.debtServiceInfo)
            {
                const customPlanAmount = customAmounts[this.getKeyAmountInput(debt.sirenaAccountId, debt.serviceId, debt.accountId, 1)];
                if(customPlanAmount !== undefined)
                {
                    amounts.plan = customPlanAmount;
				}
				else amounts.plan = Math.max(0, amounts.plan);
            }
        }

        if(debt.debtServiceInfo)
        {
            amounts.comission += calcCommisionBySppsService(parseFloat(amounts.debt) || 0, debt.debtServiceInfo);
            amounts.planComission += calcCommisionBySppsService(parseFloat(amounts.plan) || 0, debt.debtServiceInfo);
        }

        if(debt.fineServiceId && debt.fineServiceInfo)
        {
            amounts.comission += calcCommisionBySppsService(parseFloat(amounts.fine) || 0, debt.fineServiceInfo);
        }

        amounts.total =
            (!isSelectedSppsPlanAccrualsService || isSelectedSppsService ? Math.max(0, parseFloat(amounts.debt) || 0):0)
            + (!isSelectedSppsPlanAccrualsService || isSelectedSppsService ? Math.max(0, parseFloat(amounts.fine) || 0):0)
            + (isSelectedSppsPlanAccrualsService ? Math.max(0, parseFloat(amounts.plan) || 0):0)
            + (!isSelectedSppsPlanAccrualsService || isSelectedSppsService ? amounts.comission:0)
            + (isSelectedSppsPlanAccrualsService ? amounts.planComission:0)
        ;

        return amounts;
    }

    isFineChecked(compositeId = ''){
		const {selectedFineForContractsIds} = this.state;
        return selectedFineForContractsIds.includes(compositeId);
    }

    calcAmount(){
		const {selectedContractdIds, selectedSppsDebt, accounts, selectedFineForContractsIds} = this.state;
        let amount = 0;

        selectedContractdIds.forEach(compositeId => {
            const [accountId, contractId] = compositeId.split('#').map(id => id);
            const account = accounts.find(item => item.id === accountId);
            if(account)
            {
                const {contracts} = account;
                const contract = !!contracts && contracts.find(item => item.id === contractId);
                if(contract)
                {
                    const contractAmounts = this.getSirenaContractAmounts(contract);
                    const fineIsChecked = this.isFineChecked(compositeId);
                    amount += fineIsChecked ? parseFloat(contractAmounts.debt) + parseFloat(contractAmounts.fine):parseFloat(contractAmounts.debt);
                }
            }
        });

        selectedSppsDebt.forEach(sppsService => {
            const {accountId, serviceId, debtAccountId, isPlan} = sppsService;
            const account = accounts.find(item => item.id === accountId);
            if(account)
            {
                const debts = this.state[Form.getKeySppsDebtsState(accountId)];
                const debt = !!debts && debts.find(item => item.accountId === debtAccountId && item.serviceId === +serviceId);
                if(debt)
                {
                    if(isPlan === 0 || !this.isSelectedSppsService(accountId, serviceId, debtAccountId))
                    {
                        const debtAmounts = this.getSppsServiceAmounts(debt);
                        amount += debtAmounts.total;
                    }
                }
            }
        });

        return amount;
    }

    onChangeBankCard = id => (e) => {
        e.preventDefault();
        this.setState({bankCardId: id, saveBankCard: false});
    };

	changeSaveBankCard(value){
        this.setState({saveBankCard: value});
    };

    onClickShowSppsDebts = (accountId) => (e) => {
        const debtsIsLoaded = !!this.state[Form.getKeySppsDebtsIsLoadedState(accountId)];
        const debtsIsOpen = !!this.state[Form.getKeySppsDebtsIsOpenState(accountId)];
        if(debtsIsLoaded)
        {
            const data = {};
            data[Form.getKeySppsDebtsIsOpenState(accountId)] = !debtsIsOpen;
            this.setState(data);
		}
		else this.fetchSppsDebts(accountId);
    };

    onClickCreateOrder = (e) => {
        this.createOrder();
    };

    onChangeAmountInput = (accountId, serviceId, max = 0, debtAccountId = undefined, isPlan = 0, runAfterUpdate) => e => {

        const input = e.target;
        const text = input.value;
        const cursor = input.selectionStart;
        let textBeforeCursor = text.slice(0, cursor);
        let textAfterCursor = text.slice(cursor, text.length);

        const customAmounts = {...this.state.customAmounts};
        let key = this.getKeyAmountInput(accountId, serviceId, debtAccountId, isPlan);

        let value_ = e.target.value.replace(/[^\d\\.,]/g, '').replace(/,/g, '.');
        const filteredBeforeCursor = textBeforeCursor.replace(/[^\d\\.,]/g, '').replace(/,/g, '.');
        const filteredAfterCursor = textAfterCursor.replace(/[^\d\\.,]/g, '').replace(/,/g, '.');
        let value = filteredBeforeCursor + filteredAfterCursor;
        let cursorNew = filteredBeforeCursor.length;
        // Фильтруем 2 точки в строке
        if(/^.*\..*\.$/.test(value))
        {
            value = value.substr(0, value.length - 1);
        }

        if(max > 0 && value > max) value = max;
        customAmounts[key] = value;
        // корректирвка положения курсора
        let arrValue = value.split(',');
        let valueLength = parseInt(arrValue[0]).toString().length;
        let dividers = Math.floor((valueLength) / 3);
		if(valueLength%3 == 0) {
            dividers--;
        }
		if(cursorNew > 3) {
            cursorNew += dividers;
        }
        //-
        this.setState({customAmounts});

        runAfterUpdate(() => {
            input.selectionStart = cursorNew;
            input.selectionEnd = cursorNew;
        });
    };

	getKeyAmountInput(accountId, serviceId, debtAccountId = undefined, isPlan = 0)
	{
        let key = accountId + '#' + serviceId;

        if(typeof debtAccountId !== "undefined")
        {
            key += '#' + debtAccountId;
        }
        if(isPlan !== 0)
        {
            key += '#' + isPlan;
        }

        return key;
    }

    static getKeySppsDebtsState(accountId){
        return 'sppsDebts_' + accountId;
    }

    static getKeySppsDebtsIsOpenState(accountId){
        return 'sppsDebtsIsOpen_' + accountId;
    }

    static getKeySppsDebtsIsLoadedState(accountId){
        return 'sppsDebtsIsLoaded_' + accountId;
    }

    static showRequestError(error){
        $.disMsg(getErrorRequestMessage(error), {type: 'false'});
    }
}

export default Form;
